import { ReactComponent as DocumentIcon } from 'images/newIcons/documentText.svg';
import { ReactComponent as DirectoryIcon } from 'images/newIcons/folder.svg';
import { ReactComponent as RoundSync } from 'images/newIcons/roundSync.svg';
import { DocumentNode } from 'types/documents';

export const renderNodeIcon = (node: DocumentNode) => (
  <>
    {node.data.isFolder ? (
      <DirectoryIcon className="w-full h-full" />
    ) : (
      <DocumentIcon className="w-full h-full" />
    )}
  </>
);

export const renderFolderLoading = (node: DocumentNode) => (
  <div className="round-loader">
    <RoundSync width={16} height={16} className="round-loader__spinner" />
  </div>
);
